// extracted by mini-css-extract-plugin
export default {"tnav":"tnav_tnav__y0jVW","tnav-title":"tnav_tnav-title__uq7Ot","tnav-version":"tnav_tnav-version__2RnNF"};